import { ClientDataType } from 'modules/queryBuilder/types';
import { useGetFieldType } from 'modules/queryBuilder/hooks/useGetFieldType';
import { campaignFields } from '../comparator/constants';
import { useConditionStateContext, useQueryStateContext } from '../../../contexts';
import { useConditionState } from '../../../hooks/condition';
import { useResetErrorStateOnFieldChange } from './useResetErrorStateOnFieldChange';

// Update fieldType when new field is selected
export const useOnFieldChange = (dataType: ClientDataType) => {
  const getFieldType = useGetFieldType(dataType);
  const { setCondition, condition } = useConditionState();
  const { field = '' } = useConditionStateContext();
  const resetErrorStateOnFieldChange = useResetErrorStateOnFieldChange();
  const { setToLatestId } = useQueryStateContext();

  return (newField: string) => {
    // for campaigns we need to add the values property
    if (campaignFields.includes(newField) && field !== newField) {
      const newFieldType = getFieldType(newField);
      resetErrorStateOnFieldChange();
      setCondition(({ id }) => ({
        id,
        dataType,
        field: newField,
        fieldType: newFieldType,
        values: null,
      }));
      setToLatestId(condition.id);
    } else if (field !== newField) {
      const newFieldType = getFieldType(newField);
      resetErrorStateOnFieldChange();
      setCondition(({ id }) => ({
        id,
        dataType,
        field: newField,
        fieldType: newFieldType,
      }));
      setToLatestId(condition.id);
    }
  };
};
